import { Component, OnInit, OnDestroy, Renderer2, ElementRef, ViewChild, ViewChildren, QueryList, HostListener, AfterViewInit } from '@angular/core';
import { Subscription, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

import { DirectionService } from '../../direction.service';
import { DataSharingService } from '../data-shering-service/data-sharing.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from "src/app/auth/auth.service";

import { DialogService } from 'src/app/dialog/dialog.service';

import { ClustersService } from './clusters.service';

@Component({
  selector: 'app-choose-branch',
  templateUrl: './choose-branch.component.html',
  styleUrls: ['./choose-branch.component.scss'],
  host: {
    class: 'fill-screen'
  }
})

export class ChooseBranchComponent implements OnInit, OnDestroy, AfterViewInit {
  isLoading: boolean = false;
  isRTL: boolean = true;
  isDarkMode: boolean = false;
  private directionSubscription: Subscription;
  public hoveredPrintingService: string = '';
  public clusterName: string = '';
  public clusters: any[] = [];
  public filteredClusters: any[] = [];
  public filteredClustersIndexes: boolean[] = [];
  branchName: string = '';
  continueToClusterText: string = '';
  byPrinterNumberExplanation: string = '';
  userIsAuthenticated = false;
  userId: string;
  private authStatusSub: Subscription;
  isSystemSet: boolean = false;
  private branchSub: Subscription;
  private clusterSub: Subscription;
  isScreenWide: boolean = false;
  @ViewChildren('branchElement') branchElements!: QueryList<ElementRef>;
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  scrollPosition: number = 0;
  private scrollListener: () => void;

  // map
  @ViewChildren('mapBranchItem') mapBranchItems: QueryList<ElementRef>;
  mapContainerWidth: number = 0;
  mapContainerHeight: number = 0;
  public filteredBranches: any[] = [];
  branchesMapLocationsList: any[] = [
    { name: "technion", location: { x: 0.45, y: 0.09 } },
    { name: "hadarion", location: { x: 0.40, y: 0.16 } },
    { name: "rupin", location: { x: 0.39, y: 0.23 } },
    { name: "tau", location: { x: 0.32, y: 0.3 } },
    { name: "shenkar", location: { x: 0.3, y: 0.37 } },
    { name: "minhal", location: { x: 0.24, y: 0.58 } },
    { name: "bezalel", location: { x: 0.70, y: 0.35 } },
    { name: "emuna", location: { x: 0.80, y: 0.5 } },
    { name: "ort", location: { x: 0.53, y: 0.52 } },
    { name: "shluha", location: { x: 0.79, y: 0.42 } },
    { name: "nocturno", location: { x: 0.52, y: 0.45 } },
    { name: "sami", location: { x: 0.50, y: 0.62 } },
    { name: "coffee51", location: { x: 0.26, y: 0.51 } },
    { name: "shivuk", location: { x: 0.66, y: 0.21 } },
    { name: "yooletta", location: { x: 0.26, y: 0.44 } },
    { name: "ariel", location: { x: 0.68, y: 0.28 } },
  ];
  resizeObserver: any;

  // search
  searchPlaceholder: string = '';
  searchText: string = '';
  private translateSub: Subscription;
  isfilteredClustersEmpty: boolean = false;

  constructor(
    private directionService: DirectionService,
    private dataSharingService: DataSharingService,
    private router: Router,
    private authService: AuthService,
    private dialogService: DialogService,
    private translateService: TranslateService,
    private clustersService: ClustersService,
    private renderer: Renderer2,
  ) {
    this.translateService.onLangChange.subscribe(() => {
      this.updatecontinueToClusterText();
      this.updatebyPrinterNumberExplanation();
    });
    this.setSearchPlaceholder();
  }

  ngOnInit() {
    this.isLoading = true;

    // go to new site!
    const fullUrl = window.location.href;
    // console.log('Full URL:', fullUrl);
    if (!fullUrl.includes('print') && !fullUrl.includes('dev') && !fullUrl.includes('localhost')) {
      const urlParts = fullUrl.split('.');
      const urlWithoutDot = urlParts[0];
      window.location.href = 'https://print.eazix.io/qr/plotter/' + urlWithoutDot + "/new";
      return;
    }
    // // go to new site!

    this.directionService.direction$.subscribe(direction => {
      this.isRTL = direction === 'rtl';
    });

    this.translateSub = this.translateService.onLangChange.subscribe(() => {
      this.setSearchPlaceholder();
      this.searchText = '';
      this.updateClusterName();
      this.filterClusters();
    });

    this.directionService.isDarkMode$.subscribe(isDarkMode => {
      this.isDarkMode = isDarkMode;
    });

    this.isScreenWide = window.innerWidth > 786;

    this.userId = this.authService.getUserId();
    this.userIsAuthenticated = this.authService.getIsAuth();
    this.authStatusSub = this.authService
      .getAuthStatusListener()
      .subscribe(isAuthenticated => {
        this.userIsAuthenticated = isAuthenticated;
        this.userId = this.authService.getUserId();
        if (!isAuthenticated) {
          this.branchName = '';
          this.clusterName = '';
          this.isSystemSet = false;
        }
      });

    this.branchSub = this.dataSharingService.getBranch().subscribe((value) => {
      this.branchName = value;
      this.updateClusterName();
    });

    this.clusterSub = this.dataSharingService.getCluster().subscribe((value) => {
      this.clusterName = value;
    });

    this.clustersService.getClusters()
      .pipe(
        retry(3),
        catchError((error) => {
          console.error('Failed to fetch clusters after 3 attempts:', error);
          // Redirect to the new site
          window.location.href = 'https://print.eazix.io';
          return throwError(error);
        })
      )
      .subscribe((clusters) => {
        this.clusters = clusters;
        // console.log('Clusters:', clusters);
        this.filteredClusters = clusters;
        this.isLoading = false;
        this.updateClusterName();
      });
  }

  ngAfterViewInit(): void {
    if (this.scrollContainer) {
      this.scrollListener = this.renderer.listen(this.scrollContainer.nativeElement, 'scroll', () => {
        this.updateScrollPosition();
      });
    }
  }

  updateClusterName() {
    if (this.branchName !== '') {
      for (let cl of this.clusters) {
        if (cl.plotter?.some(printer => printer.serial_name === this.branchName) ||
          cl.express?.some(printer => printer.serial_name === this.branchName)) {
          this.clusterName = cl.serial_name;
          this.dataSharingService.setCluster(this.clusterName);
          if (this.clusterName && this.clusterName !== '') {
            setTimeout(() => {
              const clusterIndex = this.clusters.findIndex(
                (cluster) => cluster.serial_name === this.clusterName
              );
              if (clusterIndex !== -1) {
                const targetElement = this.branchElements.toArray()[clusterIndex];
                if (targetElement) {
                  targetElement.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
                }
              }
            }, 100);
          }
          break;
        } else {
          this.clusterName = '';
        }
      }
    }

    for (let cl of this.clusters) {
      const translatedName = this.translateService.instant('choose-branch.naming.' + cl.serial_name);
      cl.translatedName = translatedName;
    }

    setTimeout(() => { this.updateMap(); }, 0);
    this.resizeObserver = this.renderer.listen('window', 'resize', (event) => {
      setTimeout(() => { this.updateMap(); }, 0);
    });
    this.updatecontinueToClusterText();
    setTimeout(() => {
      if (this.clusterName !== '') {
        this.isSystemSet = true;
      } else {
        this.isSystemSet = false;
      }
    }, 120);
  }

  ngOnDestroy() {
    if (this.authStatusSub) {
      this.authStatusSub.unsubscribe();
    }
    if (this.branchSub) {
      this.branchSub.unsubscribe();
    }
    if (this.clusterSub) {
      this.clusterSub.unsubscribe();
    }
    if (this.scrollListener) {
      this.scrollListener();
    }
  }

  onHoverPrintingService(value: string) {
    this.hoveredPrintingService = value;
  }

  onChooseCluster(value: string) {
    if (value && value !== "") {
      this.clusterName = value;
      this.updatecontinueToClusterText();
      this.onSetCluster();
    }
  }

  onSetCluster() {
    if (this.clusterName !== "") {
      this.dataSharingService.setCluster(this.clusterName);
      this.router.navigate(['/branch']);
    }
  }

  updatecontinueToClusterText() {
    this.continueToClusterText =
      this.translateService.instant('choose-system.continue-to') +
      this.translateService.instant('choose-branch.naming.' + this.clusterName);
  }

  updatebyPrinterNumberExplanation() {
    this.byPrinterNumberExplanation = this.translateService.instant('choose-system.by-printer-number-explanation');
  }

  goToHomePage() {
    this.router.navigate(['/home']);
  }

  goToProducts() {
    // console.log('goToProducts');
    this.router.navigate(['/product']);
  }

  openPrinterNumnerDialod() {
    this.dialogService.onOpenPrinterNumberDialog();
  }

  isSu() {
    if (localStorage.getItem("roles")?.includes("su")) {
      return true;
    }
    return false;
  }

  updateMap() {
    const mapContainer = document.getElementById('map-branch-container');
    if (mapContainer) {
      this.mapContainerWidth = mapContainer.offsetWidth;
      this.mapContainerHeight = mapContainer.offsetHeight;
    }
    this.clusters.forEach((cluster, index) => {
      const location = this.branchesMapLocationsList.find(item => item.name === cluster.serial_name)?.location;
      if (location) {
        const branchElement = this.mapBranchItems.toArray()[index];
        // Check if branchElement is defined
        if (branchElement && branchElement.nativeElement) {
          // Set the 'left' and 'top' CSS properties of the branch element
          this.renderer.setStyle(branchElement.nativeElement, 'left', `${location.x * this.mapContainerWidth}px`);
          this.renderer.setStyle(branchElement.nativeElement, 'top', `${location.y * this.mapContainerHeight}px`);
        } else {
          // console.log('branchElement is not found');
        }
      } else {
        // console.log('Location is not found for branch:', cluster.serial_name);
      }
    });
  }

  // search

  private setSearchPlaceholder() {
    this.translateService.get('choose-branch.search-placeholder').subscribe((res: string) => {
      this.searchPlaceholder = res;
    });
  }

  filterClusters(): void {
    if (this.searchText && this.searchText.length > 0) {
      this.filteredClusters = [];
      this.filteredClustersIndexes = [];
      for (let cl of this.clusters) {
        if (cl.translatedName.toLowerCase().includes(this.searchText.toLowerCase())) {
          this.filteredClusters.push(cl);
          this.filteredClustersIndexes.push(true);
        } else {
          this.filteredClustersIndexes.push(false);
        }
      }
      if (this.filteredClusters.length === 0) {
        this.filteredClusters = this.clusters;
        this.isfilteredClustersEmpty = true;
        this.filteredClustersIndexes = [];
      } else {
        this.isfilteredClustersEmpty = false;
      }
    } else {
      this.filteredClusters = this.clusters;
      this.isfilteredClustersEmpty = false;
      this.filteredClustersIndexes = [];
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.isScreenWide = window.innerWidth > 768;
  }

  updateScrollPosition(): void {
    if (this.scrollContainer) {
      this.scrollPosition = this.scrollContainer.nativeElement.scrollTop;
    }
  }
  // ==================
}
